import React from "react"

import SummaryText from "./summary-text"
import SummaryScreens from "./summary-screens"
import style from "./summary.module.css"

const Summary = () => {
  
  return (
  <div className={style.summary} >
    <SummaryText />
    <SummaryScreens />
  </div>
  )
}

export default Summary
